const NAV_LINKS = [
  { label: 'O nas', href: '#o-nas' },
  { label: 'Aktualności', href: '#aktualnosci' },
  { label: 'Działaj Lokalnie', href: '#dzialaj-lokalnie' },
  { label: 'Galeria', href: '#galeria' },
  { label: 'Dokumenty', href: '#dokumenty' },
  { label: 'Samorządy', href: '#samorzady' },
  { label: 'Partnerzy', href: '#partnerzy' },
  { label: 'Kontakt', href: '#kontakt' },
];

const partnerLinks = [
  { name: 'dzialajlokalnie.pl', url: 'https://www.dzialajlokalnie.pl' },
  { name: 'pafw.pl', url: 'https://www.pafw.pl' },
  { name: 'filantropia.org.pl', url: 'https://www.filantropia.org.pl' },
  { name: 'lisewo.com', url: 'https://www.lisewo.com' },
  { name: 'grudziadz.gmina.pl', url: 'https://www.grudziadz.gmina.pl' },
  { name: 'gminachelmza.pl', url: 'https://www.gminachelmza.pl' },
  { name: 'gminaksiazki.pl', url: 'https://www.gminaksiazki.pl/' },
  { name: 'powiat-chelmno.pl', url: 'https://www.powiat-chelmno.pl' },
  { name: 'kujawsko-pomorskie.pl', url: 'https://www.kujawsko-pomorskie.pl' },
];

import kuzniaLogo from '@/assets/kil_logo.webp';
import { openCookieSettings } from '@/lib/cookieConsent';

const Footer = () => {
  return (
    <footer className="bg-foreground text-background py-12">
      <div className="container">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-10 w-10 rounded-full bg-background/15 flex items-center justify-center p-1.5">
            <img src={kuzniaLogo} alt="" aria-hidden="true" className="h-full w-full object-contain rounded-full" loading="lazy" />
          </div>
          <span className="font-heading font-bold text-lg text-background">Stowarzyszenie Kuźnia Inicjatyw Lokalnych</span>
        </div>

        <nav aria-label="Partnerzy zewnętrzni" className="flex flex-wrap gap-3 mb-8">
          {partnerLinks.map((p) => (
            <a key={p.name} href={p.url} target="_blank" rel="noopener noreferrer"
              aria-label={`${p.name} (otwiera się w nowej karcie)`}
              className="text-xs bg-background/20 text-background px-3 py-1 rounded-full hover:bg-background/30 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-background focus-visible:ring-offset-2 focus-visible:ring-offset-foreground">
              {p.name}
            </a>
          ))}
        </nav>

        <nav aria-label="Nawigacja w stopce" className="flex flex-wrap gap-x-6 gap-y-2 mb-8">
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} className="text-sm text-background hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-background focus-visible:ring-offset-2 focus-visible:ring-offset-foreground rounded">{l.label}</a>
          ))}
          <a href="/deklaracja-dostepnosci" className="text-sm text-background hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-background focus-visible:ring-offset-2 focus-visible:ring-offset-foreground rounded">
            Deklaracja dostępności
          </a>
          <a href="/polityka-prywatnosci" className="text-sm text-background hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-background focus-visible:ring-offset-2 focus-visible:ring-offset-foreground rounded">
            Polityka prywatności
          </a>
          <a href="/polityka-cookies" className="text-sm text-background hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-background focus-visible:ring-offset-2 focus-visible:ring-offset-foreground rounded">
            Polityka cookies
          </a>
          <button
            type="button"
            onClick={openCookieSettings}
            className="text-sm text-background hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-background focus-visible:ring-offset-2 focus-visible:ring-offset-foreground rounded text-left"
          >
            Ustawienia cookies
          </button>
        </nav>

        <p className="text-sm font-semibold text-secondary mb-4">#WyzwółSpołecznąEnergię!</p>

        <p className="text-xs text-background/80">
          © 2025 Stowarzyszenie Kuźnia Inicjatyw Lokalnych w Lisewie · ul. Łebińskiego 6, 86-230 Lisewo · KRS 0000149749 · Ośrodek Działaj Lokalnie od 2015 r.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
